import { useEffect } from 'react';
import { Seo } from '../../components/seo';
import { useUIStore } from '../../store/ui-store';
import { KitList } from '../../components/kits/kit-list';

function KitsListPage() {
  const { setTitle, setBreadcrumbs } = useUIStore();

  useEffect(() => {
    setBreadcrumbs([]);
    setTitle('Manage Kits');
  }, [setBreadcrumbs, setTitle]);

  return (
    <>
      <Seo title="Manage Kits" />
      <div className="px-12 pt-10 pb-[35px]">
        <KitList />
      </div>
    </>
  );
}

export default KitsListPage;
